import { Button } from '@mui/material'
import React from 'react'
import './Button.css'
function Mybutton({text,icon,link}) {
    return (
       <Button  href={link} target="_blank" className="custom_btn" download endIcon={icon?(<div className="btn_icon_container">{icon}</div>):null}>
           <span className="btn_text">{text}</span>
       </Button>
     )
}

export default Mybutton
